import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Expirations = ({
  onChange,
  disabled,
  error,
  title,
  expirations,
  vtv_provinces,
  vtv_cities,
  send_expiriation_mailing_options,
  mailing_weeks,
  ...props
}) => {

  const handleChange = event => {
    onChange(event, 'expirations')
  }

  const classes = useStyles();
  var vtv_cities_filtered = vtv_cities


  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title} VTV 
      </Typography>
      <TextField
        id="vtv_last_date"
        name="vtv_last_date"
        label="Fecha de ult. vtv"
        disabled={disabled}
        //error={(error !=='' && basic_data.vtv_last_date ==='') ? 'Debe completar este campo' :  false }
        //helperText= {(error !=='' && basic_data.vtv_last_date ==='' ) ? 'Debe completar este valor' : ''}
        type="date"
        placeholder="Ingrese la última vtv"
        onChange={handleChange}
        value={expirations.vtv_last_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='vtv_province_id' >
        <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Provincia ult. VTV</InputLabel>
        <Select native name='vtv_province_id'
            inputProps={{
              name:"vtv_province_id",
              className:"vtv_province_id"
            }}
            style={{minWidth: 150, fontSize: '0.75rem'}}
            onChange={handleChange}
            disabled={disabled}
            value={expirations.vtv_province_id}
            input={<Input id="grouped-native-select" name='vtv_province_id'/>}>
            <option value="" />
            {vtv_provinces.map((province) => <option id={province.id} value={province.id}>{province.name}
          </option>)}
        </Select>
      </FormControl>

      {(expirations.vtv_province_id !== '')?
        <FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='vtv_last_city_id' >
          <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Localidad ult. VTV</InputLabel>
          <Select native name='vtv_last_city_id'
              inputProps={{
                name:"vtv_last_city_id",
                className:"vtv_last_city_id"
              }}
              style={{minWidth: 150, fontSize: '0.75rem'}}
              disabled={disabled}
              onChange={handleChange}
              value={expirations.vtv_last_city_id}
              input={<Input id="grouped-native-select" name='vtv_last_city_id'/>}>
              <option value="" />
              {vtv_cities_filtered.map((city) => <option id={city.id} value={city.id}>{city.name}
            </option>)}
          </Select>
          {/*(error !=='' && basic_data.vtv_last_city_id ==='') && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>*/}        
        </FormControl>
        :
        ' '
      }

      <TextField
        id="rto_due_date"
        name="rto_due_date"
        label="Fecha vto. RTO"
        disabled={disabled}
        type="date"
        placeholder="Ingrese la fecha de vencimiento de RTO"
        onChange={handleChange}
        value={expirations.rto_due_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <TextField
        id="vtv_due_date"
        name="vtv_due_date"
        label="Fecha vto. VTV"
        disabled={disabled || expirations.rto_due_date !== ''}
        error={(error !=='' && expirations.vtv_due_date ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && expirations.vtv_due_date ==='' ) ? 'Debe completar este valor' : ''}
        type="date"
        placeholder="Ingrese la fecha de vencimiento VTV"
        onChange={handleChange}
        value={expirations.vtv_due_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <TextField
        id="vtv_km_expiration"
        name="vtv_km_expiration"
        label="KM vto. VTV"
        disabled={disabled}
        error={(error !=='' && expirations.km_due_date ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && expirations.km_due_date ==='' ) ? 'Debe completar este valor' : ''}
        type="integer"
        placeholder="Ingrese el km de vencimiento VTV"
        onChange={handleChange}
        value={expirations.vtv_km_expiration}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <Typography variant="h6" className="mt-2">
        {title} Otros  
      </Typography>

      <TextField
        id="fire_extinguisher_due_date"
        name="fire_extinguisher_due_date"
        label="Fecha vto. matafuego"
        disabled={disabled}
        type="date"
        placeholder="Ingrese la fecha de vencimiento de matafuego"
        onChange={handleChange}
        value={expirations.fire_extinguisher_due_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <TextField
        id="cardoc_due_date"
        name="cardoc_due_date"
        label="Fecha vto. cedula verde"
        disabled={disabled}
        error={(error !=='' && expirations.cardoc_due_date ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && expirations.cardoc_due_date ==='' ) ? 'Debe completar este valor' : ''}
        type="date"
        placeholder="Ingrese la fecha de vencimiento de cedula verde"
        onChange={handleChange}
        value={expirations.cardoc_due_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <Typography variant="h6" className="mt-2">
        Envio estado de vehículo 
      </Typography>


      <FormControl className="mt-3 mr-2" style={{minWidth: 200, fontSize: '0.75rem'}} name='send_expiration_mailing' >
        <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Enviar estado?</InputLabel>
        <Select native name='send_expiration_mailing'
            inputProps={{
              name:"send_expiration_mailing",
              className:"send_expiration_mailing"
            }}
            style={{minWidth: 200, fontSize: '0.75rem'}}
            disabled={disabled}
            onChange={handleChange}
            error={(error !=='' && expirations.send_expiration_mailing ==='') ? 'Debe completar este campo' :  false }
            value={expirations.send_expiration_mailing}
            input={<Input id="grouped-native-select" name='send_expiriation_mailing'/>}>
            <option value="" />
            {send_expiriation_mailing_options.map((send_expiriation_mailing) => <option id={send_expiriation_mailing.id} value={send_expiriation_mailing.id}>{send_expiriation_mailing.name}
          </option>)}
        </Select>
      </FormControl>


      <TextField
        id="mailing_day"
        name="mailing_day"
        label="Día de envío"
        disabled={disabled}
        type="number"
        placeholder="Ingrese el día del envío del estado"
        onChange={handleChange}
        value={expirations.mailing_day}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        InputProps={{style:{minWidth: 200, fontSize: '0.75rem'}, inputProps: { min: 1, max: 30 } }}        
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}, inputProps: { min: 1, max: 30, style:{minWidth: 200, fontSize: '0.75rem'} }}} 
      />



      {/*<FormControl className="mt-3 mr-2" style={{minWidth: 200, fontSize: '0.75rem'}} name='mailing_week' >
        <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Semana de envio?</InputLabel>
        <Select native name='mailing_week'
            inputProps={{
              name:"mailing_week",
              className:"mailing_week"
            }}
            style={{minWidth: 200, fontSize: '0.75rem'}}
            disabled={disabled}
            onChange={handleChange}
            value={expirations.mailing_week}
            input={<Input id="grouped-native-select" name='mailing_week'/>}>
            <option value="" />
            {mailing_weeks.map((mailing_week) => <option id={mailing_week.id} value={mailing_week.id}>{mailing_week.name}
          </option>)}
        </Select>
      </FormControl>*/}

      <TextField
        id="last_mailing_date"
        name="last_mailing_date"
        label="Último envío de estado"
        disabled={true}
        type="date"
        onChange={handleChange}
        value={expirations.last_mailing_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />
      <TextField
        id="last_malast_mailing_emaililing_date"
        name="last_mailing_email" 
        label="Email útimo envío de estado"
        disabled={true}
        type="text"
        onChange={handleChange}
        value={expirations.last_mailing_email}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />
      <TextField
        id="last_malast_mailing_status"
        name="last_malast_mailing_status" 
        label="Estado útimo envío de estado"
        disabled={true}
        type="text"
        value={expirations.last_mailing_status}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />


	</React.Fragment>
	)

}
export default Expirations;
